module.exports = __webpack_public_path__ + "static/img/d10-1.b7dfc67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/pc/role/d10-1.png
// module id = u21d
// module chunks = 0